import React from 'react';
import Component from '@vfuk/core-card-grid';
const CardGrid = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default CardGrid;
